<template>
  <div class="hello">
    <!-- 头部组件 -->
    <div class="box" >
      <headers type="blue"></headers>
    </div>
    <div class="header-item" v-if="false">
      <!-- <div class="content">
        <div class="title">软件著作权相关登记</div>
        <div class="text">为电脑软件、app等软件申请相关登记</div>
      </div> -->
      <el-carousel class="content" indicator-position="none" height="450px">
        <el-carousel-item v-for="(item, index) in banaerList" :key="index">
          <!-- <h3 class="small">{{ item }}</h3> -->
          <el-image
            :src="imgUrl + item.pic"
            class="imgs"
            :fit="'cover'"
          ></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="content-son">
     <!-- <div class="title">版权登记业务办理</div>-->
      <div class="content-arr-box">
        <div
          class="arr-item1"
          v-for="(item1, index1) in contentArr"
          :key="index1"
        >
          <div class="content flex">
            <div
              class="arr-item2"
              :class='item2.s == 2?"asdw":""'
              v-for="(item2, index2) in item1.arr"
              :key="index2"
            >
              <div class="frame-box flex_center">
                <img :src="item2.img" class="bg" alt="" />
                {{ item2.r }}
              </div>
              <div class="text">
                {{ item2.text }}
              </div>
              <!-- <a href=""> -->
              <div @click="go(item2.frameText)" class="button-box flex_center" v-on:mouseover="changeActive($event)" v-on:mouseout="removeActive($event)" id="fleter">
                {{ item2.buttonText }}
              </div>
              <!-- </a> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 尾部组件 -->
    <div class="c">
      <tails></tails>
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
import headers from "@/components/header";
import tails from "@/components/tail";
import bg from "@/assets/icon/首页-菱形框@2x.png";
export default {
  name: "HelloWorld",
  data() {
    return {
      showCode:false,
      msg: "Welcome to Your Vue.js App",
      bg: bg,
      state: "",
      userInfo: "",
      contentArr: [
        {
          backgeround: "",
          arr: [
            {
              frameText: "文字", // 多边形的文字
              text: "文字作品", //多边形与button中间的文字
              buttonText: "立即登记", // 按钮里的文字
              img: require("../assets/homePage/bac.png"),
              r:'Z1',
              s:1
            },
              {
              frameText: "口述", // 多边形的文字
              text: "口述作品", //多边形与button中间的文字
              buttonText: "立即登记", // 按钮里的文字
              img: require("../assets/homePage/bac.png"),
              r:'Z2',
              s:1
            },
            { 
              frameText: "口述", // 多边形的文字
              text: "音乐、戏剧、曲艺、舞蹈、杂技艺术作品", //多边形与button中间的文字
              buttonText: "立即登记", // 按钮里的文字
              img: require("../assets/homePage/bac.png"),
              r:'Z3',
              s:2
            },
            
          
          ],
        },
        {
          backgeround: "#F3F7FD",
          arr: [
            {
              frameText: "音乐", // 多边形的文字
              text: "美术、建筑作品", //多边形与button中间的文字
              buttonText: "立即登记", // 按钮里的文字
              img: require("../assets/homePage/bac.png"),
              r:'Z4',
              s:1
            },
              {
              frameText: "音乐", // 多边形的文字
              text: "摄影作品", //多边形与button中间的文字
              buttonText: "立即登记", // 按钮里的文字
              img: require("../assets/homePage/bac.png"),
              r:'Z5',
              s:1
            },
            {
              frameText: "喜剧", // 多边形的文字
              text: "视听作品", //多边形与button中间的文字
              buttonText: "立即登记", // 按钮里的文字
              img: require("../assets/homePage/bac.png"),
              r:'Z6',
              s:2
            },
          ],
        },
        {
          backgeround: "",
          arr: [
            // {
            //   frameText: "杂技", // 多边形的文字
            //   text:
            //     "工程设计图、产品设计图 及其文字说明 地图、示意图等图形和模型作品著作权登记", //多边形与button中间的文字
            //   buttonText: "立即登记", // 按钮里的文字
            //   img: require("../assets/homePage/img9.png"),
            // },
            // {
            //   frameText: "美术", // 多边形的文字
            //   text: "电影作品和类似电影方式创作的作品著作权登记", //多边形与button中间的文字
            //   buttonText: "立即登记", // 按钮里的文字
            //   img: require("../assets/homePage/img10.png"),
            // },

            {
              frameText: "曲艺", // 多边形的文字
              text: "图形作品和模型作品 ", //多边形与button中间的文字
              buttonText: "立即登记", // 按钮里的文字
              img: require("../assets/homePage/bac.png"),
              r:'Z7',
              s:1
            },
            {
              frameText: "舞蹈", // 多边形的文字
              text: "其他", //多边形与button中间的文字
              buttonText: "立即登记", // 按钮里的文字
              img: require("../assets/homePage/bac.png"),
              r:'Z8',
              s:1
            },
            {
              frameText: "计算机软件", // 多边形的文字
              text: "计算机软件", //多边形与button中间的文字
              buttonText: "立即登记", // 按钮里的文字
              img: require("../assets/homePage/bac.png"),
              r:'R0',
              s:2
            },
          ],
        },
      ], //
      banaerList: [],
      imgUrl: this.$imgUrl,
      linkList: [],
    };
  },
  mounted() {
    console.log(this,'this')
    // console.log(this.$route.query.openid,'this.$route.query')
    if(this.$route.query.openid){
      window.sessionStorage.setItem("openid",this.$route.query.openid);
    }
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    // console.log(this.userInfo,"aaa");
    if (
      this.userInfo == undefined ||
      this.userInfo == "" ||
      this.userInfo == null
    ) {
      this.state = "1";
    } else {
      this.state = "2";
    }
    this.getbanaer();
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.userInfo = userInfo;

  },
  methods: {
     changeActive($event){
    $event.currentTarget.className="miysd flex_center";
      },
      removeActive($event){
        $event.currentTarget.className="button-box flex_center";
      },
    go(e) {
      if(e == '计算机软件'){
        this.$router.push('/computer')
        return
      }
      if(this.userInfo){
        if(e == '计算机软件'){
          this.$router.push('/computer')
        }else{
          this.$router.push("/copyright");
        }
      } else {  
        Message.error("请登录");
        this.$router.push("/login");
      }
    },
    getbanaer() {
      this.$axios(this.$url + "/pc/userLogin/findBanaer").then((res) => {
        // console.log(res.data);
        let data = res.data;
        if (data.success) {
          this.banaerList = data.r;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
  },
  components: {
    headers,
    tails,
  },
  // mounted() {
  //   // console.log(getbanaer)
  // },
};
</script>

<style lang='less' scoped>

.box {
  background:  #0068b7;
}
.c {
  background: #f2f2f2;
}
.header-item {
  // padding-top: 100px;
  background:  #0068b7;
  font-weight: bold;
  box-sizing: border-box;
  // height: 380px;
  .title {
    width: 504px;
    height: 78px;
    font-size: 46px;
    font-weight: 600;
    line-height: 78px;
    color: #ffffff;
    opacity: 1;
  }
  .text {
    padding: 15px 0 70px;
    font-size: 22px;
  }
}
.content-son {
  padding: 10px 0 0;
  text-align: center;
  color:  #0068b7;

  .title {
    font-weight: bold;
    font-size: 28px;
  }

  .content-arr-box {
        width: 1200px;
    margin: 0 auto;
    .arr-item1 {
      // padding: 40px 0;
      border-bottom: 1px solid #a9a9a9;
      .flex_center {
        position: relative;
      }

      .bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 88px;
    height: 100px;
        z-index: 0;
      }
      .arr-item2 {
       
       
        .frame-box {
          font-size: 24px;
          font-weight: bold;
          width: 88px;
          height: 100px;
          margin: 0 auto;
          
        }

        .text {
          padding: 10px 0px;
          font-size: 18px;
          font-weight: 600;
          // line-height: 30px;
          // min-height: 80px;
              line-height: 20px;
    min-height: 40px;
          color: #000;
          opacity: 1;
          // padding-top: 0px;
          width: 163px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .button-box {
          cursor: pointer;
          margin: 5px auto 0;
          border-radius: 6px;
          width: 100px;
          line-height: 36px;
          font-size: 14px;
          cursor: pointer;
          height: 30px;
          outline: none;
          cursor: pointer;
          background-color: #fff;
          color: #a9a9a9;
          border: 1px solid #a9a9a9;
          border-radius: 8px;
        }
      }
    }
  }
}
        /deep/.el-carousel__arrow {
          display: none;
        }
        .imgs {
          object-fit: cover;
          width: 90%;
          height: 90%;
        }
        .miysd {
          margin: 5px auto 0;
          border-radius: 6px;
          width: 100px;
          line-height: 36px;
          font-size: 14px;
          height: 30px;
          background-color: #2164d2;
          color: #fff;
          border: 1px solid #2164d2;
          border-radius: 8px;
          cursor: pointer;
        }
        .arr-item2{
           text-align: center;
        width: 33%;
            border-right: 1px solid #a9a9a9;
    padding: 20px 0px;
        }
        div{
          .asdw{
            border-right: none;
          }
        }
        @media screen and (max-width: 1024px) {
        *{
          font-size: 14px;
        }
        .content-son .content-arr-box{
          width: 100%;
        }
        /deep/.content{
          width: 100%;
        }
        .content{
          .flex{
            display: none;
          }
        }

        .content-arr-box{
        width: 100%;
      }
        .links{
        margin-left: 0px;
      }
      .link{
        margin-left: 0px;
      }
      .content-son .content-arr-box .arr-item1 .arr-item2 .frame-box{
        width: 4.375rem;
        height: 5.051rem;
      }
      .content-son .content-arr-box .arr-item1 .bg{
        width: 4.375rem;
        height: 5.051rem;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
      }
      .content-son .content-arr-box .arr-item1 .arr-item2 .text{
        font-size: 0.88rem;
        padding: 0.8rem 0rem;
        text-align: center;
        width:100%;
        overflow: hidden;
        text-overflow: ellipsis;
        height: 1.2rem;
      }
      .content-son .content-arr-box .arr-item1 .arr-item2 .button-box{
        width: 6.25rem;
        height: 1.835rem;
        line-height:1.835rem;
        font-size: 1rem;
      }
      .arr-item2{
        flex:1;
      }
      .content-son .content-arr-box .arr-item1 .arr-item2 .frame-box{
        font-size:1.28rem ;
      }
          /deep/.stawers{
      display: none;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/HelloWorld.vue